import Guard from '../../services/Middleware'

export default [
  {
    path: '/Configuracao',
    name:'Configuração',
    component: () => import('@/views/configuracao/index.vue'),
    beforeEnter: Guard.auth
  },
]